import 'antd/dist/reset.css';
import './App.css';
import Header from './Components/Header';
import { Outlet, useLocation } from 'react-router-dom';
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';
import { Button } from "antd";
import Context from './context/UserContext';
import SummaryApi from './common';
import { useDispatch } from 'react-redux';
import Home from './Pages/users/Home';
import Footer from './Components/Footer';
import { setUserDetails } from './Stores/userSlice';


import TopHeader from './Components/TopHeader';

 
function App() {
  const location = useLocation();
  const path = location.pathname;
  
 
  // List all admin/seller routes where header should be hidden
  const hideHeaderRoutes = [
    '/seller-signup',
    '/seller-signin',
    '/seller/dashboard',
    '/platformadmin-signup',
    '/platformadmin-login',
    '/admin/dashboard'
  ];
 
  // Also hide header for admin dashboard children
  const shouldHideHeader =
    hideHeaderRoutes.some(route => path.startsWith(route)) ||
    path.startsWith('/admin/dashboard/');
 
  return (
    
   
        <div className='App'>
          {!shouldHideHeader && <TopHeader />}
          {!shouldHideHeader && <Header />}
          <main>
            <Outlet />
          </main>
          <Footer />
        </div>
  );
}
 
export default App;
 